<template>
    <van-swipe
        ref="swiper"
        v-bind="options"
        :width="width"
        :height="height"
        :initial-swipe="initialSwipe"
        :show-indicators="isIndicators"
        @change="onChange"
    >
        <slot v-if="isCustom"></slot>
        <van-swipe-item
            v-else
            v-for="(item, index) in data"
            class="swiper-item"
            :class="itemCls"
            :key="index"
        >
            <slot :item="item"></slot>
        </van-swipe-item>
    </van-swipe>
</template>
<script>
export default {
    model: {
        prop: "activateIndex",
        event: "activateChange"
    },
    props: {
        // van-swipe配置
        options: {
            type: Object
        },
        // 初始化的索引位置
        initialSwipe: {
            type: Number,
            default: 0
        },
        // 当前激活索引
        activateIndex: {
            type: Number
        },
        // 是否显示提示点
        showIndicators: {
            type: Boolean,
            default: true
        },
        // 设计高度
        designHeight: {
            type: String
        },
        // 设计宽度
        designWidth: {
            type: String,
            default: "750"
        },

        // 单项样式
        itemCls: {
            type: String,
            default: ""
        },
        // 数据源
        data: {
            type: Array,
            default() {
                return [];
            }
        },
        // 是否自定义数据模版
        isCustom: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        data(v) {
            // 数据发生变化时，抛出选项切换事件
            if (v.length) {
                this.initial();
            }
        }
    },
    computed: {
        // 是否显示提示点
        isIndicators() {
            // 直接配置不显示或者只有一条数据时不显示提示点
            return !(!this.showIndicators || this.data.length == 0);
        },
        // 实际高
        height() {
            return this.getPx(this.designHeight);
        },
        // 实际宽
        width() {
            return this.getPx(this.designWidth);
        }
    },
    methods: {
        resize() {
            this.$refs.swiper.resize();
        },
        swipeTo(v, options) {
            this.$refs.swiper.swipeTo(v, { immediate: true });
        },
        onChange(v) {
            const me = this;
            let itemData = null;
            me.data.forEach((item, index) => {
                if (index == v) {
                    itemData = item;
                }
            });
            me.$emit("activateChange", v);
            me.$emit("activateItemChange", itemData, v);
        },
        // length 设计长度
        // 因为ui给的是基于750px的设计长度，这里需要转换
        getPx(length) {
            if (!length) {
                return null;
            }
            // 设计稿最大宽度
            const maxWidth = 750,
                // 屏幕宽度
                width = document.body.clientWidth;
            // 实际长度为屏幕宽度*宽度比例
            // 宽度比例等于组件宽度除以设计稿最大宽度
            return width * (length / maxWidth);
        },
        initial() {
            const me = this,
                data = me.data;
            // 初始化时抛出事件
            if (data && data.length) {
                me.$emit(
                    "activateItemChange",
                    data[me.initialSwipe],
                    me.initialSwipe
                );
            }
        }
    },
    // 初始化时
    created() {
        this.initial();
    },
    // 页面被激活时初始化
    activated() {
        this.initial();
    }
};
</script>
